export const COUNTRIES = [
    {
        name: 'Belgium',
        code: 'be',
    },
    {
        name: 'Germany',
        code: 'de',
    },
    {
        name: 'The Netherlands',
        code: 'nl',
    },
    {
        name: 'United States',
        code: 'us',
    },
    {
        name: 'United Kingdom',
        code: 'gb',
    },
    {
        name: 'Canada',
        code: 'ca',
    },
    {
        name: 'France',
        code: 'fr',
    },
    {
        name: 'Sweden',
        code: 'se',
    },
    {
        name: 'Italy',
        code: 'it',
    },
    {
        name: 'Spain',
        code: 'es',
    },
    {
        name: 'Russia',
        code: 'ru',
    },
    {
        name: 'India',
        code: 'in',
    }]